import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PfeServiceActivatorService } from './service/service-activator.service';
import { NgxPfeUtilModule } from '../pfe-util/pfe-util.module';

@NgModule({
  imports: [CommonModule, NgxPfeUtilModule],
  declarations: [],
  providers: [PfeServiceActivatorService],
})
export class PfeServiceActivatorModule {}
